import { CSSProperties } from 'react';
import { ColumnType, TableProps } from 'antd/lib/table';
import { SorterResult } from 'antd/lib/table/interface';

import { Links } from 'links';

import { TFieldProps } from './form';

export type TColumn<T> = ColumnType<T> & {
  type?: TColumn.type;
  hidden?: boolean;
  titleInfo?: {
    info: string;
    title: string;
  };
  pathname?: Links; // for IDRedirect, check getColumnByType
  dateFormat?: string;
  sortOrderInfo?: SorterResult<T>;
};

export namespace TColumn {

  export enum type {
    Date = 'date',
    Tags = 'tags',
    Image = 'image',
    Status = 'status',
    Percent = 'percent',
    Ellipsis = 'ellipsis',
    Currency = 'currency',
    Checkbox = 'checkbox',
    TitleInfo = 'titleInfo',
    IDRedirect = 'IDRedirect',
    FetchImage = 'fetchImage',
    FetchImageByID = 'fetchImageByID',
  }

}

export type TEditableColumn<T> = TColumn<T> & {
  field?: Omit<TFieldProps, 'name'> | (({ isFieldAdding }: { isFieldAdding?: boolean; isFieldEditing?: boolean; }) => Omit<TFieldProps, 'name'> | null);
  getStyles?: (record: T) => CSSProperties;
};

export interface IMilesTableProps<T> extends Omit<TableProps<T>, 'title' | 'columns' | 'dataSource'> {
  title?: string;
  columns: TColumn<T>[];
  dataSource?: T[];
  titleExtraNode?: React.ReactNode;
  underTableNode?: React.ReactNode;
  verticalScroll?: boolean;
  horizontalScroll?: boolean;
}

export enum InitialTableActions {
  Edit = 'edit',
  Toggle = 'toggle',
  Delete = 'delete',
  Approve = 'approve',
}

export interface IInitialTableActions {
  type: InitialTableActions;
  title?: string;
}
